import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import MapView from './components/MapView';
import { nodes, modes } from './data/campusGraph';
import { findPath } from './hooks/usePathfinder';

import './App.css';

export default function App() {
const [start, setStart] = useState('library');
const [end, setEnd] = useState('unionSouth');
  const [mode, setMode] = useState('fastest');
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const currentMode = modes.find(m => m.id === mode);

  const handleFindRoute = async () => {
    setIsLoading(true);

    const localResult = findPath(start, end, mode);

    if (!localResult) {
      setResult(null);
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch("https://us-central1-stridecheesehacks.cloudfunctions.net/stride-api", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
  start: start,
  end: end,
  mode: mode.toUpperCase()
})
      });

      const cloudData = await response.json();

      setResult({
        ...localResult,
        aiReasoning: cloudData.status === "success" ? cloudData.reasoning : null
      });
    } catch (err) {
      console.error("Cloud error, using local data", err);
      setResult(localResult);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-layout" style={{ display: 'flex', height: '100vh' }}>
      <Sidebar 
        nodes={nodes}
        start={start}
        end={end}
        mode={mode}
        modes={modes}
        result={result}
        isLoading={isLoading}
        currentMode={currentMode}
        onStartChange={setStart}
        onEndChange={setEnd}
        onModeChange={setMode}
        onFindRoute={handleFindRoute}
      />
      <MapView 
        result={result}
        start={start}
        end={end}
        currentMode={currentMode}
      />
    </div>
  );
}